import script from "./InspectionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionManagement.vue?vue&type=script&setup=true&lang=js"

import "./InspectionManagement.vue?vue&type=style&index=0&id=5a38b225&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a38b225"]])

export default __exports__